module.exports = __webpack_public_path__ + "static/media/ucsc_logo.75edce1c.png";